var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoDesplegableDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.82 25.82",
    style: {
      enableBackground: "new 0 0 25.82 25.82"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-arrow-dropdown",
    transform: "translate(25.823 25.823) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3554",
    d: "M19.64,15.72c0.47-0.47,0.47-1.23,0-1.69L13.7,8.11c-0.45-0.45-1.18-0.47-1.65-0.04 L6.19,13.9c-0.51,0.43-0.57,1.19-0.14,1.69c0.43,0.51,1.19,0.57,1.69,0.14c0.05-0.04,0.1-0.09,0.14-0.14l5.03-4.95l5.03,5.08 C18.42,16.2,19.17,16.19,19.64,15.72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3555",
    d: "M25.82,12.91C25.82,5.78,20.04,0,12.91,0S0,5.78,0,12.91s5.78,12.91,12.91,12.91 c0,0,0,0,0,0C20.04,25.82,25.82,20.04,25.82,12.91C25.82,12.91,25.82,12.91,25.82,12.91z M5.19,20.63 C0.89,16.41,0.82,9.49,5.05,5.19s11.14-4.37,15.44-0.14c0.05,0.05,0.09,0.09,0.14,0.14c4.3,4.23,4.37,11.14,0.14,15.44 S9.63,25,5.33,20.77C5.28,20.73,5.23,20.68,5.19,20.63z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoDesplegableDown);
export default __webpack_public_path__ + "static/media/icono-desplegable-down.d6aaee177ad4f5ff4a7827005291a530.svg";
export { ForwardRef as ReactComponent };